import Mutations from '../../odata/mutations';

export default { ...new Mutations('product'), ...new Mutations('products') };
